
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import mentee from "../../assets/new images/mentor.png";
import backgroundImage from "../../assets/new images/becomementor.png";
import TeamBioSection from "../../components/root/TeamBioSection";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";

const BecomeMentor = () => {
  const { t } = useTranslation();
  return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/become-a-mentor"]}
        path="/become-a-mentor"
      />

      <Hero bgImage={backgroundImage}
        badgeText={`✨ ${t("hero.badge")}`}
        titleLines={[t("becomeMentor.heroTitle1"), t("becomeMentor.heroTitle2")]}
        subtitle={t("becomeMentor.heroSubtitle")}
        primary={{ label: t("hero.findMentor"), href: "/mentors" }}
        secondary={{ label: t("hero.tryAi"), href: "/ai-career" }}
        curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
        heightClass="h-[100vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

     <TeamBioSection
  heading={t("becomeMentor.teamHeading")}
  body={[t("becomeMentor.teamBody1"), t("becomeMentor.teamBody2")]}
  img={mentee}
  showDot={false}                 // hide the name dot
  showCorners={true}              // keep the corner pills
  reverse={false}                 // image on the left (like your screenshot)
  cta={{ label: t("hero.findMentor"), href: "/become-a-mentor" }}
/>


    </div>
  );
};

export default BecomeMentor;
